var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.190391 12.4407C0.512559 13.1463 1.17555 13.584 1.92189 13.584H3.65463C3.93949 14.9638 5.10501 16 6.49942 16C7.89382 16 9.05935 14.9638 9.34545 13.5853H11.0782C11.8245 13.5853 12.4875 13.1476 12.8097 12.442C13.1306 11.739 13.0411 10.9263 12.5758 10.3187C11.5123 8.92968 10.9488 7.60866 10.9488 6.49931C10.9488 4.89212 10.9488 0 6.49942 0C2.05001 0 2.05001 4.89081 2.05001 6.498C2.05001 7.60735 1.48777 8.92838 0.422999 10.3187C-0.0409734 10.9249 -0.130534 11.739 0.190391 12.4407ZM6.49942 14.6933C5.79786 14.6933 5.20079 14.2334 4.95201 13.5853H8.04558C7.79804 14.2321 7.20097 14.6933 6.49942 14.6933ZM1.39324 11.1366C2.65454 9.48893 3.2939 7.92879 3.2939 6.498C3.2939 1.89596 5.00675 1.30535 6.49942 1.30535C7.99209 1.30535 9.70493 1.89596 9.70493 6.498C9.70493 7.92879 10.3455 9.49024 11.6056 11.1366C11.7698 11.3522 11.7996 11.6279 11.6865 11.8762C11.5708 12.1271 11.3444 12.2786 11.0769 12.2786H1.92065C1.65321 12.2786 1.42682 12.1284 1.31114 11.8762C1.19794 11.6279 1.22904 11.3509 1.39324 11.1366Z",
    fill: "#1B8C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellHover);
export default __webpack_public_path__ + "static/media/bell-hover.f3e72414e31a8be84b1d39f0702f74f6.svg";
export { ForwardRef as ReactComponent };